module.exports = __webpack_public_path__ + "static/media/rbi_logo.1f4de3de.svg";